/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.printHeader = function( event, view, bMulti) {
    var obj = {};
    obj.content = document.createElement( "div");
    var et = document.createElement( "h2");
    var vt = null;
    
    obj.style = "@media print {body{font-family:Georgia;font-size:12pt;width:6in;}.page{width:7in;}h2,h3{margin:0.5em;}.hdr{text-align:center;}";
    
    obj.content.className = "hdr";
    et.textContent = event;
    obj.content.appendChild( et);
    
    if( bMulti && view !== "") {
        vt = document.createElement( "h3");
        vt.textContent = view;
        obj.content.appendChild( vt);
    }
    return obj;
};